/* WebComponentLabelPrinting template */
import { Host, Fragment, h } from '@stencil/core';
import WebComponentLabelPrintingStandaloneTsx from "./dia-label-printing-standalone";
import WebComponentLabelPrintingLoaderTsx from "./dia-label-printing-loader";

const WebComponentLabelPrintingStandaloneSwitchTsx = (context) => {
    //@ts-ignore
    return context.ref.useStandalone ? (
        <WebComponentLabelPrintingStandaloneTsx ref={context.ref} content={
            <Fragment>{context.ref.StencilRouterOutput(context)}</Fragment>
        }/>
    ) : (
        <dia-grid>
            <main>
                <article>
                    <section>
                        {context.ref.StencilRouterOutput(context)}
                    </section>
                </article>
            </main>
        </dia-grid>
    )
};

const WebComponentLabelPrintingTsx = (context) => (
  <Host>
    <dialog data-backdrop={true}>
      <dialog-content>
        { context.ref.useRouter ? WebComponentLabelPrintingStandaloneSwitchTsx(context) : '' }
        { context.ref.loading || context.ref.error ? WebComponentLabelPrintingLoaderTsx(context) : '' }
      </dialog-content>
    </dialog>
  </Host>
);

export default WebComponentLabelPrintingTsx;
